module.exports = __webpack_public_path__ + "static/media/system.fa5fb311.png";